/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withTranslation } from 'react-i18next'
import styles from './FinesYes.module.scss'
import { useHistory } from 'react-router-dom'
import BackAnchor from '../../../../shared/components/BackAnchor'

const FinesYesView = ({ t, i18n }) => {
  let history = useHistory()

  const continueFlow = () => {
    history.push(`/${i18n.language}${t('routes.school_question')}`)
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <BackAnchor />
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3>
            {t('fines_yes.desc')}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={
                i18n.language === 'en'
                  ? 'https://isd.acol.ca/isd/doj/FinePayment/Intro.do'
                  : 'https://isd.acol.ca/isd/doj/FinePayment/index.do?lang=fr'
              }
            >
              {t('fines_yes.pay_your_fines_online')}
              <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
            </a>
          </h3>
        </div>
      </div>
      <div className={styles['display_flex_top_margin']}>
        <div className="row">
          <div className="col-xs-12 col-md-8">
            <button
              className={['btn-lg btn-default', styles['continue_margin']].join(' ')}
              onClick={continueFlow}
              value={t('fines_yes.continue')}
              name={t('fines_yes.continue')}
            >
              {t('fines_yes.continue')}
            </button>
          </div>
        </div>
      </div>
      {/* <div className={styles['margin_back']}>
        <div className="row">
          <div className="col-xs-12">
            <a
              onClick={() => history.push(`/${i18n.language}${t('routes.fines_question')}`)}
              href={`/${i18n.language}${t('routes.fines_question')}`}
            >
              {t('fines_yes.back')}
              <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
            </a>
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default withTranslation('common')(FinesYesView)
